import { ShieldCheck } from "lucide-react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { PathNavigator } from "@/components/PathNavigator";
import { routeMeta, routes } from "@/data/siteContent";
import { useAuth } from "@/components/AuthContext";
import { KnowledgeSearch } from "@/components/KnowledgeSearch";
import { useEffect } from "react";
import { HeaderAccountControl } from "@/components/HeaderAccountControl";
import { LocationTrail } from "@/components/LocationTrail";
import { MobileBackToTop } from "@/components/MobileBackToTop";
import { SeoManager } from "@/components/SeoManager";

const pageMeta = {
  "/member": { label: "Member Access", color: "#FFE24A", theme: "sun" },
  "/member/journey": { label: "Guided Membership", color: "#D4AF37", theme: "sun" },
  "/payment/success": { label: "Payment Confirmation", color: "#55FF8A", theme: "green" },
  "/methods": { label: "Methods & Accuracy", color: "#2FFFE0", theme: "aqua" },
  "/privacy": { label: "Privacy", color: "#55FF8A", theme: "green" },
  "/wisdom": { label: "Wisdom", color: "#FF7900", theme: "ember" },
  "/knowledge/intuitive": { label: "Intuition & Channeling", color: "#C86BFF", theme: "lilac" },
  "/today": { label: "Today", color: "#FFE24A", theme: "sun" },
  "/sign-in": { label: "Sign In", color: "#2FFFE0", theme: "aqua" },
};

export const SiteShell = () => {
  const { pathname,search } = useLocation();
  const deepBlueprint=pathname.startsWith("/app/blueprint/explain/")?{label:"Blueprint Explanation",color:"#00E5D4",theme:"aqua"}:null;
  const current = deepBlueprint || routes.find((route) => route.path === pathname) || routeMeta[pathname] || pageMeta[pathname] || routes[0];
  const { user, loading, logout } = useAuth();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) window.setTimeout(() => document.querySelector(hash)?.scrollIntoView({ block: "start" }), 0);
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={`site-shell theme-${current.theme}`} style={{ "--page-accent": current.color }}><SeoManager/>
      <a href="#main-content" className="skip-link" data-testid="skip-to-content-link">Skip to content</a><header className="site-header" data-testid="site-header">
        <a href="/" className="brand" data-testid="shane-ai-logo-link" aria-label="SHANE-AI home">
          <img src="/shane-ai-logo.png" alt="SHANE-AI" data-testid="shane-ai-main-logo" />
        </a>
        <div className="header-actions"><KnowledgeSearch/><HeaderAccountControl user={user} loading={loading} logout={logout} returnPath={`${pathname}${search}`}/></div>
      </header>
      <PathNavigator />
      <MobileBackToTop/>
      <main className="page-frame" id="main-content"><LocationTrail/><Outlet /></main>
      <footer className="site-footer">
        <span data-testid="footer-brand">SHANE-AI</span>
        <span data-testid="privacy-message"><ShieldCheck size={16} /> Your reflections belong to you.</span>
        <Link to="/methods" data-testid="methods-link">Methods & accuracy</Link>
        <Link to="/privacy" data-testid="privacy-link">Privacy</Link>
        <span data-testid="footer-signature">Higher self · Human first</span>
      </footer>
    </div>
  );
};